import React from 'react';
import { Stack, SxProps, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';
import { TimeRange, TimeRangeDropdownFilter } from 'modules/home/components/DropdownFilter';
import { ResponsiveDatePicker } from '../ResponsiveDatePicker';

export type PeriodFilterDateRange = {
  startDate?: string
  endDate?: string
}

interface PeriodFilterControlsProps {
  timeRange: TimeRange
  onTimeRangeChange: (timeRange: TimeRange) => void
  customDateRange: PeriodFilterDateRange
  onCustomDateRangeChange: (updates: Partial<PeriodFilterDateRange>) => void
  leadingFilters?: React.ReactNode
  timeRangeSx?: SxProps
  datePickerSx?: SxProps
}

export const PeriodFilterControls: React.FC<PeriodFilterControlsProps> = ({
  timeRange,
  onTimeRangeChange,
  customDateRange,
  onCustomDateRangeChange,
  leadingFilters,
  timeRangeSx,
  datePickerSx
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  return (
    <Stack gap={2}>
      <Stack gap={2} direction={'row'} flexWrap={{ xs: 'wrap', md: 'nowrap' }} width='100%'>
        {leadingFilters}
        <TimeRangeDropdownFilter
          size='small'
          value={timeRange}
          onChangeValue={onTimeRangeChange}
          fullWidth
          sx={{
            width: { md: theme.spacing(31) },
            flex: { xs: 1, md: 'none' },
            ...timeRangeSx
          }}
        />
      </Stack>
      {timeRange === TimeRange.customRange && (
        <Stack direction="row" gap={2} flexWrap={{ xs: 'wrap', md: 'nowrap' }} width='100%'>
          <ResponsiveDatePicker
            label={formatMessage({ id: 'From' })}
            value={customDateRange.startDate}
            maxDate={customDateRange.endDate ? dayjs(customDateRange.endDate) : undefined}
            onChange={startDate => onCustomDateRangeChange({ startDate })}
            size='small'
            fullWidth
            sx={{
              width: { md: theme.spacing(31) },
              flex: { xs: 1, md: 'none' },
              ...datePickerSx
            }}
          />
          <ResponsiveDatePicker
            label={formatMessage({ id: 'To' })}
            value={customDateRange.endDate}
            minDate={customDateRange.startDate ? dayjs(customDateRange.startDate) : undefined}
            onChange={endDate => onCustomDateRangeChange({ endDate })}
            size='small'
            fullWidth
            sx={{
              width: { md: theme.spacing(31) },
              flex: { xs: 1, md: 'none' },
              ...datePickerSx
            }}
          />
        </Stack>
      )}
    </Stack>
  );
};
